import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {useSelector, useDispatch} from "react-redux";

//helpers:
import useTableDetails from "./useTableDetails";
import {getTranslatedGroupName} from "../../../../../_metronic/_helpers";

//actions:
import {
    fetchCredentials,
    fetchGroups,
    selectActiveAdminCredentials,
    selectActiveNonAdminCredentials,
    selectCredentialsStatus,
    selectAllGroups,
} from "../../../../redux_slices/settingsCredentialsSlice";

//components:
import UsersTable from "../partials/Table";

const UsersPage = () => {
    const {t} = useTranslation();
    const {formatRow} = useTableDetails();
    const EMPTY_MSG = t("ADMINPANEL.USERS.TABLE.EMPTY_MESSAGE");
    //redux:
    const dispatch = useDispatch();
    //store:
    const allGroups = useSelector(selectAllGroups);
    const adminCredentials = useSelector(selectActiveAdminCredentials);
    const nonAdminCredentials = useSelector(selectActiveNonAdminCredentials);

    const {type, error} = useSelector(selectCredentialsStatus);
    const isLoading = () => type === "loading" || type === "idle";

    useEffect(() => {
        dispatch(fetchCredentials());
        dispatch(fetchGroups());
    }, []);

    return (
        <>
            <UsersTable
                title={t("ADMINPANEL.USERS.ADMIN")}
                rows={adminCredentials}
                formatRow={formatRow}
                isLoading={isLoading()}
                errorMessage={error}
                emptyMessage={EMPTY_MSG}
            />
            {allGroups.map(({group_id, name}) => {
                let rows = nonAdminCredentials.filter(cred => cred.groups?.[0]?.group_id === group_id);
                if (group_id === 1)
                    rows = nonAdminCredentials.filter(cred => cred.groups?.[0]?.group_id === 1 || !cred.groups?.[0]);

                if (group_id !== 2)
                    return (
                        <UsersTable
                            title={getTranslatedGroupName(t, {group_id, name})}
                            rows={rows}
                            formatRow={formatRow}
                            isLoading={isLoading()}
                            errorMessage={error}
                            emptyMessage={EMPTY_MSG}
                        />
                    );
            })}
        </>
    );
};

export default UsersPage;
